import { render } from "./auto-rotate-rke2-certs.vue?vue&type=template&id=15a689d8&scoped=true"
import script from "./auto-rotate-rke2-certs.vue?vue&type=script&lang=js"
export * from "./auto-rotate-rke2-certs.vue?vue&type=script&lang=js"

import "./auto-rotate-rke2-certs.vue?vue&type=style&index=0&id=15a689d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a689d8"]])

export default __exports__